import React from "react";
import GlobalEntitiesTable from "./GlobalEnttitiesTable";
import "./globalentities.scss";
import Layout from "../../Layout";

const GlobalEntities = () => {
  return (
    <Layout
      title="My Entities"
      subtitle="Find all the entities under management and its parent companies in one place. Quickly search, filter, and access essential information for efficient management."
    >
      <div className="card">
        <GlobalEntitiesTable />
      </div>
    </Layout>
  );
};

export default GlobalEntities;
